import Box from '@mui/material/Box';
import LinearProgress, { LinearProgressProps } from '@mui/material/LinearProgress';
import Typography from '@mui/material/Typography';

const LinearProgressWithLabel = ({ value, ...rest }: LinearProgressProps & { value: number }) => {
    const validValue = Math.min(100, Math.abs(Math.max(0, value)));

    return (
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Box sx={{ width: '100%', mr: 1 }}>
                <LinearProgress variant="determinate" {...rest} value={validValue} />
            </Box>
            <Box sx={{ minWidth: 35 }}>
                <Typography variant="body2" color="text.secondary">{`${Math.round(validValue)}%`}</Typography>
            </Box>
        </Box>
    );
};

export default LinearProgressWithLabel;
